<!--
参考文档：https://github.com/hinesboy/mavonEditor 
-->
<template>
  <div class="markedown-document-content">
    <!-- <span class="del-icon">X</span>   v-model="value" -->
    <mavon-editor
      v-model="value"
      :toolbars="toolbars"
      :editable="false"
      :toolbarsFlag="false"
      :subfield="false"
      :defaultOpen="preview"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'markdown',
  components: {},
  props: {
    subfield: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: ``,
    },
  },
  data() {
    return {
      logTemp: undefined,
      preview: 'preview',
      documentText: '',
      // fileUrl:require('@/views/game/components/md/quickStart.md'),
      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        underline: true, // 下划线
        strikethrough: true, // 中划线
        mark: true, // 标记
        superscript: true, // 上角标
        subscript: true, // 下角标
        quote: true, // 引用
        ol: true, // 有序列表
        ul: true, // 无序列表
        // link: true, // 链接
        link: false, // 链接
        imagelink: true, // 图片链接
        code: true, // code
        table: true, // 表格
        fullscreen: true, // 全屏编辑
        readmodel: true, // 沉浸式阅读
        htmlcode: true, // 展示html源码
        help: true, // 帮助
        undo: true, // 上一步
        redo: true, // 下一步
        trash: true, // 清空
        save: true, // 保存（触发events中的save事件）

        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true, // 右对齐
        subfield: true, // 单双栏模式
        preview: true, // 预览
        navigation: true, // 导航目录
      },
    }
  },
  watch: {
    value(val) {
      // console.log('markdownDoc', val)
      let docBody = document.querySelector('.v-show-content')
      if (docBody && docBody.scrollTop) {
        docBody.scrollTop = 0
      }
    },
    markdownDoc: {
      handler(val) {
        this.documentText = val
        // console.log('markdownDoc', val)
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    // ...mapGetters(['markdownDoc']),
    markdownDoc() {
      return this.$store.state.markdownDoc //用computed接收
    },
  },
  created() {
    this.logTemp = console.log
    console.log = (message) => {
      console.info(message)
    }
  },
  mounted() {
    // this.init()
    // setTimeout(() => {
    //   console.log(
    //     'this.$store.state.markdownDoc',
    //     this.$store.state.markdownDoc
    //   )
    // }, 2000)
    console.log = this.logTemp
  },
  methods: {
    // init() {
    //   var editor = editormd('test-editor', {
    //     path: 'editormd/lib/',
    //   })
    // },
  },
}
</script>

<style>
@import '~@/assets/styles/github.min.css';
/* @import '~@/assets/styles/katex.min.css'; */
@import '~@/assets/styles/markdown.css';
</style>

<style lang="scss" scope>
.markedown-document-content {
  display: inline-block;
  // padding-top:10px;
  // background: rgb(251, 251, 251);
  // background: rgba(94, 147, 255, 0.1);
  .del-icon {
    position: absolute;
  }
  //  .markdown-body .highlight pre, .markdown-body pre{
  //   color: #333;
  // }
}
.markdown-body .highlight pre,
.markdown-body pre {
  color: #333;
}
.v-show-content > ul {
  // display: none;
}
</style>
